import { render } from "./BalModal.vue?vue&type=template&id=24cd8b10&scoped=true&ts=true"
import script from "./BalModal.vue?vue&type=script&lang=ts"
export * from "./BalModal.vue?vue&type=script&lang=ts"

import "./BalModal.vue?vue&type=style&index=0&id=24cd8b10&scoped=true&lang=css"
import "./BalModal.vue?vue&type=style&index=1&id=24cd8b10&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cd8b10"]])

export default __exports__